// Route: /study-plan — LEGACY redirect → /courses.
//
// «Учебный план» стал «Курсом» (обучающая система, docs/plans/
// LEARNING-SYSTEM-VISION.md). Модель данных та же (курс == study_plans),
// сменилась только адресация. Канонический роут — /courses.
// Старые ссылки/закладки/письма/deep-links не должны ломаться: мгновенный
// redirect с сохранением search (?status/?q/?demo).
//
// `search as never`: схема search целевого роута принадлежит /courses и может
// разойтись с легаси-набором ключей. Прокидываем как есть — `validateSearch`
// на стороне /courses (zod `.object()`) сам отбросит лишнее; жёсткая типизация
// здесь только связала бы два роута лишней зависимостью.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	status: z.enum(["all", "active", "paused", "archived"]).optional(),
	q: z.string().optional(),
	demo: z
		.enum(["default", "loading", "empty", "error", "streaming", "generating", "quota-exceeded"])
		.optional(),
});

export const Route = createFileRoute("/study-plan/")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		// `status` у курсов не знает значения `paused` (там `active|archived|all`),
		// и закладка `?status=paused` упала бы в zod целевого роута. Остальное
		// совпадает по имени и типу. Проверено 2026-08-14.
		const status = search.status === "paused" ? undefined : search.status;
		throw redirect({
			to: "/courses",
			search: {
				...(search.q ? { q: search.q } : {}),
				...(status ? { status } : {}),
			},
			replace: true,
		});
	},
});
